import { BffApiClient } from '@/common/services/api/bffClient';
import { shopEndpoints } from '../endpoints/shopEndpoints';
import type { ProductModel } from '../types/shopServicesTypes';

export class ShopService {
  private static getApi() {
    return BffApiClient.getInstance();
  }

  static async getShopItems(): Promise<ProductModel[]> {
    const response = await this.getApi().get<ProductModel[]>(shopEndpoints.getShopItems);
    return response.data as ProductModel[];
  }
}

export default ShopService;
